/**
 * @ngdoc    directive
 * @name     csm.ui.validators.directive:emailValidator
 * @restrict A
 * @param    {string=} csmRequired      "false"=value is not required.
 * @param    {string=} emailValidator   Error popup title.
 * @param    {string=} disableValidator "true"=skip validation.
 *
 * @description
 * Validator to verify a valid email address input.
 **/
/* @ngInject */
export function emailValidator(CSMValidatorService) {
  var RE_EMAIL = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,13}/;

  return CSMValidatorService.makeDirective({
    doValidate: function (value) {
      var error = CSMValidatorService.BaseValidator.prototype.doValidate.call(
        this,
        value
      );
      return (
        error ||
        (value && !RE_EMAIL.test(value) ? 'Invalid email format' : null)
      );
    }
  });
}
